/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ResponseDataSelectorObjectCommonDataFromJSON, ResponseDataSelectorObjectCommonDataToJSON } from './ResponseDataSelectorObjectCommonData';
export function ResponseDataSelectorObjectCommonFromJSON(json) {
    return ResponseDataSelectorObjectCommonFromJSONTyped(json, false);
}
export function ResponseDataSelectorObjectCommonFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        status: !exists(json, 'status') ? undefined : json['status'],
        data: !exists(json, 'data') ? undefined : ResponseDataSelectorObjectCommonDataFromJSON(json['data'])
    };
}
export function ResponseDataSelectorObjectCommonToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        status: value.status,
        data: ResponseDataSelectorObjectCommonDataToJSON(value.data)
    };
}
